<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowMarketingSpendPer',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'marketing_spend', throughMonth),
          this.getYtdByField(yearObj, 'gross_revenue', throughMonth),
        );
      },
    },
  };
</script>
